import { makeAutoObservable } from 'mobx';

import { AccessInheritanceAwareCommand, MoveToCollectionRequest } from '@/drive/entities/DriveDestinationCommand';
import { DriveItem, DriveItemType, ProductItem } from '@/drive/entities/DriveItem/DriveItem';
import { DriveContainerId, DriveItemId } from '@/drive/entities/DriveItemId';
import { toAccessInheritanceSubject } from '@/drive/helpers/toAccessInheritanceSubject';
import { AccessInheritanceSubject } from '@/drive/types/AccessInheritanceSubject';

export class MoveDriveItemCommand implements AccessInheritanceAwareCommand {
  constructor(
    readonly driveItem: DriveItem,
    readonly currentParentId: DriveContainerId,
  ) {
    makeAutoObservable(this, {
      driveItem: false,
      driveItemId: false,
      driveItemType: false,
      currentParentId: false,
    });
  }

  get driveItemId(): DriveItemId {
    return this.driveItem.id;
  }

  get driveItemType(): DriveItemType {
    return this.driveItem.type;
  }

  get collectionRequest(): Nullable<MoveToCollectionRequest> {
    if (this.driveItem instanceof ProductItem && this.driveItem.productType && this.driveItem.productId) {
      return {
        productType: this.driveItem.productType,
        productIds: [this.driveItem.productId],
        productItem: this.driveItem,
      };
    }

    return null;
  }

  async getAccessSubjects(): Promise<AccessInheritanceSubject[]> {
    const subject = toAccessInheritanceSubject(this.driveItem);

    return subject ? [subject] : [];
  }
}
